import { useState } from "react";
import emailjs from "@emailjs/browser";
import "../Styles/Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setAlert({ show: false, type: "", message: "" });

    const serviceID = "service_axzbp5k";
    const templateID = "template_iwrwnwr";
    const userID = "wrEILDWyMBZb98oUo";

    emailjs
      .send(
        serviceID,
        templateID,
        {
          ...formData,
          time: new Date().toLocaleString(),
        },
        userID
      )
      .then((response) => {
        setIsLoading(false);
        setAlert({
          show: true,
          type: "success",
          message: "Message sent successfully! I'll get back to you soon.",
        });
        setFormData({ name: "", email: "", message: "", number: "" });
      })
      .catch((error) => {
        setIsLoading(false);
        setAlert({
          show: true,
          type: "error",
          message: "Failed to send message. Please try again.",
        });
      });
  };

  const closeAlert = () => {
    setAlert({ show: false, type: "", message: "" });
  };

  return (
    <section id="mainContact" className="designer-contact-section">
      <div className="designer-contact-container">
        <div className="designer-contact-info">
          <h2>Let's Connect</h2>
          <p>
            Interested in working together or have a question? Fill out the form
            or reach out directly.
          </p>
          <div className="designer-contact-details">
            <div>
              <strong>Email:</strong> disenacreates@gmail.com
            </div>
            <div>
              <strong>Phone:</strong> +234 7040081235
            </div>
            <div>
              <strong>Location:</strong> Nigeria
            </div>
          </div>
        </div>
        <div className="designer-contact-form">
          <h3>Contact Form</h3>
          {alert.show && (
            <div
              className={`designer-alert ${
                alert.type === "success" ? "success" : "error"
              }`}
            >
              <span>{alert.message}</span>
              <button onClick={closeAlert}>&times;</button>
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">
                Name <span className="required-text">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your name"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">
                Email <span className="required-text">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="you@email.com"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="number">Phone</label>
              <input
                type="tel"
                id="number"
                name="number"
                value={formData.number}
                onChange={handleChange}
                placeholder="Your phone (optional)"
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">
                Message <span className="required-text">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                placeholder="Type your message here..."
                required
              ></textarea>
            </div>
            <button
              type="submit"
              id="submitMsg"
              disabled={isLoading}
              className="designer-submit-btn"
            >
              {isLoading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
